import { AppConfigModel } from "../abstract/app-config.model";

export class JournalType extends AppConfigModel {

    static override CLASS_NAME: string = 'JournalType';
}
